import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '@services/seo.service';
@Component({
    selector: 'app-ordenar',
    templateUrl: './ordenar.component.html',
    styleUrls: ['./ordenar.component.css'],
    standalone: false
})
export class OrdenarComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private seo: SeoService
  ) {
    if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
   }

  ngOnInit(): void {
    this.seo.update({
      title: 'Como ordenar | Clave Winds',
      description: 'Guia para comprar instrumentos y accesorios de viento en Clave Winds.',
      canonical: this.seo.absoluteUrl('/ordenar')
    });
  }
}
